<template>
	<div class="col">
		<div class="card">
			<div class="card-header">
				<div class="card-title">Detalhes da prova</div>
			</div>
			<div class="card-body pb-0">
				<div class="row">
					<div class="col-md-6 col-sm-12">
						<a
							href="#revision"
							class="card-title fw-bolder fs-5 mb-3 d-block"
							>Seu desempenho</a
						>
						<div class="py-1">
							<span class="text-dark fs-1 fw-bolder me-2"
								>{{ props.score }}%</span
							>
							<span
								v-if="props.score >= 70"
								class="fw-bold text-muted fs-4"
								>Aprovado</span
							>
							<span v-else class="fw-bold text-muted fs-4"
								>Reprovado</span
							>
						</div>
						<div
							class="progress h-7px bg-opacity-50 mt-7 mb-7"
							:class="{
								'bg-danger': props.score < 70,
								'bg-success': props.score > 70,
							}">
							<div
								class="progress-bar"
								:class="{
									'bg-danger': props.score < 70,
									'bg-success': props.score > 70,
								}"
								role="progressbar"
								:style="{ width: props.score + '%' }"
								aria-valuenow="{{ $score }}"
								aria-valuemin="0"
								aria-valuemax="100"></div>
						</div>

						<div class="row">
							<div class="col">
								<div class="text-dark fs-3 fw-bolder me-2">
									Duração da Prova
								</div>
								<div class="text-gray-600 fs-4">
									{{ props.exam_duration }}
								</div>
								<!-- <div class="text-dark fs-3 fw-bolder me-2">
									Horário Limite
								</div>
								<div class="text-gray-600 fs-4">
									<span v-if="props.deadline">{{
										props.deadline
									}}</span>
									<span v-else>Sem limite de tempo</span>
								</div> -->
							</div>

							<div class="col">
								<div class="text-dark fs-3 fw-bolder me-2">
									Inicio Prova
								</div>
								<div class="text-gray-600 fs-4">
									{{ props.exam_started_at }}
								</div>
								<!-- <div class="text-dark fs-3 fw-bolder me-2">
									Término Prova
								</div>
								<div class="text-gray-600 fs-4">
									{{ props.exam_finished_at }}
								</div> -->
							</div>
						</div>

						<div class="row mt-2" v-if="user_role === 4">
							<div class="d-grid gap-2">
								<a class="btn-audit btn btn-info p-3">
									<i class="fas fa-info-circle ml-2"></i> Ver
									trilha de auditoria
								</a>
							</div>
						</div>

						<div
							class="row mt-2"
							v-if="
								props.module_id !== 'FINAL' && props.score >= 70
							">
							<div class="d-grid gap-2">
								<a
									class="btn btn-success p-3"
									:href="props.continue_course_url">
									<i class="fas fa-arrow-right ml-2"></i>
									Continuar o curso
								</a>
							</div>
						</div>

						<div
							class="row mt-2"
							v-if="
								props.module_id !== 'FINAL' &&
								props.module_id !== 'MOCK'
							">
							<div class="d-grid gap-2">
								<a
									class="btn btn-secondary p-3"
									:href="props.module_url + '?retry=true'">
									<i class="fas fa-check ml-2"></i> Tentar
									novamente
								</a>
							</div>
						</div>

						<div
							class="row mt-2"
							v-if="props.module_id === 'FINAL'">
							<div class="d-grid gap-2">
								<a
									class="btn btn-success p-3"
									:href="props.logout_url"
									@click="stopBrowserWebcam">
									<i class="fa fa-check-circle ml-2"></i>
									Finalizar e sair
								</a>
							</div>
						</div>
					</div>

					<div class="col-md-6 col-sm-12">
						<span
							class="fs-5 fw-bold text-gray-600 pb-5 d-block mt-4"
							>Resumo da prova:</span
						>
						<div
							class="border border-gray-300 border-dashed rounded py-3 px-3 mb-3">
							<div class="fs-4 fw-bolder text-gray-700">
								<span class="text-dark fs-1 fw-bolder me-2">{{
									props.count_right_answers
								}}</span>
								<span
									class="svg-icon svg-icon-3 svg-icon-success">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="16"
										height="16"
										fill="green"
										class="bi bi-check-all"
										viewBox="0 0 16 16">
										<path
											d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z" />
									</svg>
								</span>
							</div>
							<div class="h3 fw-bold text-muted">
								Respostas corretas
							</div>
						</div>
						<div
							class="border border-gray-300 border-dashed rounded py-3 px-3 mb-3">
							<div class="fs-4 fw-bolder text-gray-700">
								<span class="text-dark fs-1 fw-bolder me-2">{{
									props.count_wrong_answers
								}}</span>
								<span
									class="svg-icon svg-icon-3 svg-icon-success">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="16"
										height="16"
										fill="red"
										class="bi bi-x-circle"
										viewBox="0 0 16 16">
										<path
											d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
										<path
											d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
									</svg>
								</span>
							</div>
							<div class="h3 fw-bold text-muted">
								Respostas incorretas
							</div>
						</div>
						<div
							class="border border-gray-300 border-dashed rounded py-3 px-3 mb-3">
							<div class="fs-4 fw-bolder text-gray-700">
								<span class="text-dark fs-1 fw-bolder me-2">{{
									props.count_skipped_answers
								}}</span>
								<span
									class="svg-icon svg-icon-3 svg-icon-success">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="16"
										height="16"
										fill="orange"
										class="bi bi-bookmark-x"
										viewBox="0 0 16 16">
										<path
											fill-rule="evenodd"
											d="M6.146 5.146a.5.5 0 0 1 .708 0L8 6.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 7l1.147 1.146a.5.5 0 0 1-.708.708L8 7.707 6.854 8.854a.5.5 0 1 1-.708-.708L7.293 7 6.146 5.854a.5.5 0 0 1 0-.708z" />
										<path
											d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z" />
									</svg>
								</span>
							</div>
							<div class="h3 fw-bold text-muted">
								Questões não respondidas
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { usePage } from '@inertiajs/vue3';
	import { AuthUser } from 'resources/js/Interfaces/AuthUser';
	import { browserWebcamStreamingStore } from '../../stores/browserWebcamStreaming';

	const props = defineProps({
		score: { type: Number, required: true },
		exam_duration: { type: Number, required: true },
		deadline: { type: String, required: true },
		exam_started_at: { type: String, required: true },
		exam_finished_at: { type: String, required: true },
		count_right_answers: { type: Number, required: true },
		count_wrong_answers: { type: Number, required: true },
		count_skipped_answers: { type: Number, required: true },
		module_id: { type: String, required: true },
		logout_url: { type: String, required: true },
		module_url: { type: String, required: true },
		continue_course_url: { type: String, required: true },
	});

	const auth_user = usePage().props?.auth_user as AuthUser;
	const user_role = auth_user.user_role;
	const browserWebcam = browserWebcamStreamingStore();

	function stopBrowserWebcam() {
		browserWebcam.stop('exam-feedback-logout');
	}
</script>
